import {
  ApiBlueprint,
  createApiFactory,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import {
  ALL_RELATIONS,
  ALL_RELATION_PAIRS,
  catalogGraphApiRef,
  DefaultCatalogGraphApi,
} from '@backstage/plugin-catalog-graph';
import {
  INHERITS_WORKS_ON_BEHALF_OF,
  INHERITS_WORKS_ON_BEHALF_OF_BY,
  WORKS_ON_BEHALF_OF,
  WORKS_ON_BEHALF_OF_BY,
} from '@internal/backstage-catalog-utils';

// PAT-677 (Team Data Model v2) / PAT-1066: register the worksOnBehalfOf and
// inheritsWorksOnBehalfOf relation pairs with the Catalog Graph plugin so EntityCatalogGraphCard renders it by
// default alongside the built-in relations, instead of it only being
// present in the underlying entity data. See DefaultCatalogGraphApi —
// the plugin's own default implementation only knows ALL_RELATIONS/
// ALL_RELATION_PAIRS unless overridden here.
export function createCatalogGraphApi() {
  return new DefaultCatalogGraphApi({
    knownRelations: [
      ...ALL_RELATIONS,
      WORKS_ON_BEHALF_OF,
      WORKS_ON_BEHALF_OF_BY,
      INHERITS_WORKS_ON_BEHALF_OF,
      INHERITS_WORKS_ON_BEHALF_OF_BY,
    ],
    knownRelationPairs: [
      ...ALL_RELATION_PAIRS,
      [WORKS_ON_BEHALF_OF, WORKS_ON_BEHALF_OF_BY],
      [INHERITS_WORKS_ON_BEHALF_OF, INHERITS_WORKS_ON_BEHALF_OF_BY],
    ],
    defaultRelationTypes: { exclude: [] },
  });
}

// PAT-1021: the catalog-graph plugin is the upstream `/alpha` one, whose API
// extension is unnamed (`api:catalog-graph`). This extension is unnamed too, so
// it gets the same id and replaces the plugin's default API instead of being
// rejected as a second factory for `catalogGraphApiRef`. Pinned by index.test.ts.
export const catalogGraphModule = createFrontendModule({
  pluginId: 'catalog-graph',
  extensions: [
    ApiBlueprint.make({
      params: defineParams =>
        defineParams(
          createApiFactory({
            api: catalogGraphApiRef,
            deps: {},
            factory: createCatalogGraphApi,
          }),
        ),
    }),
  ],
});
